import get from 'lodash/get';

import { ApiActions } from '../../constants/ApiActions';
import { Map } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map<$TSFixMe>({});
export type EntitiesArtistState = typeof INITIAL_STATE;

export default createReducer(INITIAL_STATE, {
  [ApiActions.CREATE_STATION_SUCCESS]: saveArtistData,
  [ApiActions.FETCH_STATIONS_SUCCESS]: saveArtistData,
  [ApiActions.SEARCH_RECOMMENDATIONS_SUCCESS]: saveArtistData,
  [ApiActions.FETCH_GENRES_BY_CATEGORY_ID_SUCCESS]: saveArtistData,
});

function saveArtistData(state: EntitiesArtistState, action: $TSFixMe): EntitiesArtistState {
  if (get(action, 'response.entities.artists')) {
    return state.mergeDeep(action.response.entities.artists);
  }
  return state;
}
